import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadEvacuationsListBegin, loadEvacuationsListFailed, loadEvacuationsListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

const MAX_VIOLATIONS_PAGE_SIZE = 100;
const CLIENT_ONLY_FILTERS = ['search'];

const getServerFilter = (filter = {}) => {
  if (!filter || typeof filter !== 'object') {
    return {};
  }
  return Object.keys(filter).reduce((acc, key) => {
    if (!CLIENT_ONLY_FILTERS.includes(key) && filter[key]) {
      acc[key] = filter[key];
    }
    return acc;
  }, {});
};

function* loadViolationsPage(action, page, filter) {
  let pool = {
    page_size: MAX_VIOLATIONS_PAGE_SIZE,
    page,
  };
  if (typeof filter === 'object' && Object.keys(filter).length) {
    pool = addFilterQueryWithCondition(filter, pool);
  }
  const dataResponse = yield makeRequest(`${BACKEND_URL}/violations`, pool, action, 'GET', true);
  const data = yield getBodyJson(dataResponse, {});
  return {
    response: dataResponse,
    data,
  };
}

export default function* loadEvacuationsList(action) {
  try {
    const { payload = {} } = action;
    const {
      filter,
    } = payload;
    const serverFilter = getServerFilter(filter);
    if (typeof serverFilter === 'object' && Object.keys(serverFilter).length) {
      yield delay(LOADING_DELAY);
    }
    yield put(loadEvacuationsListBegin());
    const firstPage = yield call(loadViolationsPage, action, 1, serverFilter);

    if (firstPage.response.status === OK) {
      const allData = Array.isArray(firstPage.data?.data) ? [...firstPage.data.data] : [];
      const totalPages = Math.max(Number(firstPage.data?.meta?.pages || 1), 1);
      for (let page = 2; page <= totalPages; page++) {
        const pageData = yield call(loadViolationsPage, action, page, serverFilter);
        if (pageData.response.status !== OK) {
          yield put(loadEvacuationsListFailed());
          yield call(rejectActionPromise(action, pageData.data));
          return;
        }
        if (Array.isArray(pageData.data?.data)) {
          allData.push(...pageData.data.data);
        }
      }

      const data = {
        data: allData,
        meta: {
          page: 1,
          limit: allData.length || MAX_VIOLATIONS_PAGE_SIZE,
          total: allData.length,
          pages: 1,
        },
      };
      yield put(loadEvacuationsListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadEvacuationsListFailed());
      yield call(rejectActionPromise(action, firstPage.data?.data || firstPage.data));
    }
  } catch (e) {
    yield put(loadEvacuationsListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
